export const bandData = {
  name: "Searching Fusion",
  tagline: "Where Progressive Fusion Meets Pure Energy",
  location: "Northwest Indiana",
  foundedYear: 2024,
  email: "Searchingfusion@gmail.com",
  social: {
    facebook: "https://www.facebook.com/share/19ksgiwNfs/",
    youtube: "https://youtube.com/@searchingfusion?si=Ihe1X_gRI4emZHpD"
  },
  description: "We are a power trio consisting of three young musicians that want to push the boundaries of fusion. We can play anything from jazz standards to progressive rock. We are based out of Northwest Indiana, each of us coming from diverse musical backgrounds. We do covers and originals, highlighting artists that have inspired us all to be the musicians that we are.",
  members: [
    {
      id: 1,
      name: "Mason Kutin",
      age: 16,
      instrument: "Guitar",
      description: "Mason is a guitarist with dreams of going to top music schools. He has focused in music such as classical, jazz, rock, metal, and bluegrass/country. His mentors include Ric Fierabracci, Jeff Kollman, and Marco Villareal.",
      image: "https://customer-assets.emergentagent.com/job_searching-fusion/artifacts/mbvmcnuq_Snapchat-1026079079.jpg"
    },
    {
      id: 2,
      name: "Billy Pouch",
      age: 25,
      instrument: "Bass",
      description: "Billy has played bass for over a decade in a wide variety of musical environments, including theater, jazz, orchestral music, rock/metal & singer-songwriter. He possesses a passion for progressive rock, lush compositions, and exploratory grooves. Mentors include Ric Fierabracci & Nick Rapley.",
      image: "https://customer-assets.emergentagent.com/job_searching-fusion/artifacts/1hp7y8gp_Snapchat-1552962870.jpg"
    },
    {
      id: 3,
      name: "Chris Peffers",
      age: 23,
      instrument: "Drums",
      description: "Chris is a drummer and percussionist with a Bachelor's in Music from Columbia College Chicago. Now a drum instructor, he has focused on excelling in odd meter based music and marching chops. Mentors include Willie Waldman, Kofi Baker, and Ric Fierabracci.",
      image: "https://customer-assets.emergentagent.com/job_searching-fusion/artifacts/8vm56ylw_image000002%282%29.jpg"
    }
  ],
  influences: [
    "Chick Corea", "Jeff Beck", "Rush", "Stevie Wonder", "Steve Vai",
    "Dixie Dregs", "King Crimson", "Yes", "Genesis", "Mahavishnu Orchestra",
    "Return to Forever", "Weather Report", "Cosmosquad"
  ],
  upcomingShows: [
    {
      id: 1,
      date: "2026-02-06",
      venue: "Leroy's Hot Stuff",
      city: "Porter, IN",
      time: "7-11pm",
      ticketLink: null
    },
    {
      id: 2,
      date: "2026-04-04",
      venue: "219 Taproom",
      city: "Chesterton, IN",
      time: "7-10pm",
      ticketLink: null
    }
  ],
  news: [
    {
      id: 1,
      title: "Debut Album Coming 2026",
      description: "We're excited to announce our debut album will be released in 2026, showcasing our original fusion compositions.",
      date: "2025"
    },
    {
      id: 2,
      title: "First Single Dropping Before Spring 2026",
      description: "Get ready! Our first single from the upcoming album will be released before spring 2026.",
      date: "2025"
    }
  ]
};
